import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Element } from 'react-scroll';
import { propShape, propStr } from '../../../../helpers/custom-prop-types';
import FileInputFieldComponent from '../../Common/Fields/FileInputFieldComponent';
import Image from '../../Common/Image';
import InputError from '../../Common/InputError';
const FileFieldAndLabel = (props) => {
    const { alt, description, input, label, meta, noImageType } = props;
    return (_jsxs(Element, Object.assign({ className: 'form form-solution cf', name: `${input.name}_view` }, { children: [_jsx("h3", { children: label }), _jsxs("div", Object.assign({ className: 'form-solution-upload is-flex' }, { children: [_jsx("div", Object.assign({ className: 'file-view picture' }, { children: _jsx(Image, { alt: alt, isObjectFit: true, noImageType: noImageType, src: input.value }) })), _jsxs("div", Object.assign({ className: 'file-upload-picture' }, { children: [_jsx(FileInputFieldComponent, { accept: 'image/*', input: input, isDisabled: false, submitButtonClassName: 'upload-file-button btn btn-tertiary small' }), _jsx("div", Object.assign({ className: 'font-default' }, { children: _jsx("small", { children: description }) }))] }))] })), _jsx(InputError, { className: 'mt1', meta: meta })] })));
};
FileFieldAndLabel.propTypes = {
    alt: propStr().isRequired,
    description: propStr().isRequired,
    input: propShape().isRequired,
    label: propStr().isRequired,
    meta: propShape().isRequired,
    noImageType: Image.propTypes.noImageType,
};
FileFieldAndLabel.defaultProps = {
    noImageType: Image.defaultProps.noImageType,
};
export default FileFieldAndLabel;
